import React from 'react';
import FormInput from './FormInput';

const AdditionalInformation = ({
  formData,
  handleChange,
  handleFocus,
  handleBlur,
  getDisplayValue
}) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <FormInput
        label="Metal"
        name="metal"
        value={formData.metal || ''}
        onChange={handleChange}
      />

      <FormInput
        label="Composition (%)"
        name="composition"
        value={formData.composition || ''}
        onChange={handleChange}
      />

      <FormInput
        label="Weight (g)"
        name="weight"
        type="number"
        step="0.0001"
        min="0"
        value={formData.weight || ''}
        onChange={handleChange}
      />

      <FormInput
        label="Diameter (mm)"
        name="diameter"
        type="number"
        step="0.01"
        min="0"
        value={formData.diameter || ''}
        onChange={handleChange}
      />

      <FormInput
        label="Edge"
        name="edge"
        value={formData.edge || ''}
        onChange={handleChange}
      />

      <FormInput
        label="Mintage"
        name="mintage"
        value={getDisplayValue('mintage', formData.mintage)}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />

      <FormInput
        label="Minor Variety"
        name="minor_variety"
        value={formData.minor_variety}
        onChange={handleChange}
      />

      <FormInput
        label="Die Variety"
        name="die_variety"
        value={formData.die_variety}
        onChange={handleChange}
      />

      <FormInput
        label="Ref. #"
        name="reference_number"
        value={formData.reference_number || ''}
        onChange={handleChange}
        maxLength={100}
      />

      <FormInput
        label="Assayer"
        name="assayer"
        value={formData.assayer || ''}
        onChange={handleChange}
        maxLength={100}
      />

    </div>
  );
};

export default AdditionalInformation;
